import type { GetSurveysResponse_Type as TicketSurvey } from '@zendesk/zqa-services/tickets'
import { api, errorHandlerHook } from '@/api'
import { getRequestHeaders } from '../../api'

export const getTicketSurveys = (externalId: string, connectionId: number) =>
  api
    .extend({ hooks: { afterResponse: undefined } })
    .get(`ticket/connection/${connectionId}/surveys`, {
      headers: getRequestHeaders(),
      searchParams: { externalId: encodeURIComponent(externalId) },
      hooks: {
        afterResponse: [
          ({ response }) => {
            if (response.status === 404) return new Response('{"types": []}')
            return response
          },
          errorHandlerHook,
        ],
      },
    })
    .json<{ types: TicketSurvey[] }>()
